import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VideoSearchState } from './models/video-search.models';

export const selectVideoSearchState = createFeatureSelector<VideoSearchState>('videoSearch');

export const selectSearchResults = createSelector(
  selectVideoSearchState,
  (state: VideoSearchState) => state.searchResults
);

export const selectIsLinkVisible = createSelector(
  selectVideoSearchState,
  (state: VideoSearchState) => state.isLinkVisible
);

export const selectPrimaryResult = createSelector(
  selectSearchResults,
  (results) => results.length > 0 ? results[0] : null
);

export const selectHasResults = createSelector(
  selectSearchResults,
  (results) => results.length > 0
);
